<template>
  <v-btn
    small fab dark falt fixed
    right
    style="top: calc(54% + 50px)"
    class="setting-fab"
    color="blue"
    @click="$emit('click', $event)"
  >
    <v-icon>mdi-message-alert-outline</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'NegativeFeedbackComment',
};
</script>

<style scoped>

</style>
